import React, { useState } from 'react';
import './Login.css';
import logo from './assets/Upload.svg';

function Register({ onRegister, onBackToLogin }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    setLoading(true);

    try {
      await onRegister({
        name: formData.name,
        email: formData.email,
        password: formData.password
      });
    } catch (registerError) {
      setError(registerError.message || 'No fue posible crear la cuenta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={logo} alt="Pile" className="login-logo" />

        <p>Crea tu cuenta para comenzar</p>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Nombre"
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Correo"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <div className="password-field">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="Contraseña"
              value={formData.password}
              onChange={handleChange}
              required
            />

            <button
              type="button"
              className={`password-toggle ${showPassword ? 'is-visible' : ''}`}
              onClick={() => setShowPassword((current) => !current)}
              aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            >
              <span className="password-eye-icon" aria-hidden="true"></span>
            </button>
          </div>

          <div className="password-field">
            <input
              type={showPassword ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="Repetir contraseña"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />

            <button
              type="button"
              className={`password-toggle ${showPassword ? 'is-visible' : ''}`}
              onClick={() => setShowPassword((current) => !current)}
              aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            >
              <span className="password-eye-icon" aria-hidden="true"></span>
            </button>
          </div>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="login-primary-button"
            disabled={loading}
          >
            {loading ? 'Creando cuenta...' : 'Crear cuenta'}
          </button>

          <button
            type="button"
            className="login-secondary-button"
            onClick={onBackToLogin}
          >
            Volver a iniciar sesión
          </button>
        </form>
      </div>
    </div>
  );
}

export default Register;
